<template>
  <div class="artisio-tabs" :class="uniqueId" ref="customTabs">
    <b-tabs class="custom-tabs" ref="tabs" v-bind:value="value" :content-class="contentClass">
      <template v-if="scrollable" v-slot:tabs-start>
        <li class="nav-item left-arrow hover-cursor " @click="onLeftArrowClick">
          <a class="nav-link border-right">
            <font-awesome-icon class="icon" icon="chevron-left"/>
          </a>
        </li>
      </template>
      <template v-if="scrollable" v-slot:tabs-end>
        <li class="nav-item right-arrow hover-cursor e" @click="onRightArrowClick">
          <a class="nav-link border-left">
            <font-awesome-icon class="icon" icon="chevron-right"/>
          </a>
        </li>
      </template>
      <slot></slot>
    </b-tabs>
  </div>
</template>

<script>
  import $ from 'jquery';
  import uuidV4 from 'uuid'

  export default {
    props: {
      value: {
        type: Number,
        default: 0,
      },
      contentClass: {
        type: String,
        default: ''
      },
      uniqueId: {
        type: String,
        default: uuidV4()
      }
    },
    name: "ArtisioTabs",
    data() {
      return {
        scrollable: false,
      }
    },
    methods: {
      onLeftArrowClick() {
        let $el = $(`.${this.uniqueId} .nav-tabs`)
        $el.scrollLeft(-200)
      },
      onRightArrowClick() {
        let $el = $(`.${this.uniqueId} .nav-tabs`)
        $el.scrollLeft(200)
      },
      isScrollable() {
        let $el = $(`.${this.uniqueId} .nav-tabs`)
        if ($el && $el.length > 0) {
          this.scrollable = $el[0].clientWidth < $el[0].scrollWidth
        }
      }
    },
    created() {
      this.isScrollable();
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.isScrollable);
        this.isScrollable();
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.isScrollable)
    },
  }
</script>

<style lang="scss" scoped>
  .artisio-tabs {
    /deep/ {
      .nav-tabs {
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-behavior: smooth;

        &::-webkit-scrollbar {
          display: none;
        }

        .nav-item.left-arrow, .nav-item.right-arrow {
          position: sticky;
          border-bottom: 0.1em solid #e3e8ee;
          background-color: white;

          .nav-link {

            &:hover {
              border-bottom: none;
              color: inherit;
            }
          }
        }

        .nav-item.right-arrow {
          right: 0;
        }

        .nav-item.left-arrow {
          left: 0;
        }
      }
    }
  }

</style>
